import { getRouteApi } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'

import { ContactMetadataManage } from './ContactMetadataManage'

const routeApi = getRouteApi('/_app/relationships/$id/contact/add/$contactId')

export const ContactAddDialogContainer = () => {
  const { contactId, id } = routeApi.useParams()
  const { contactName } = routeApi.useSearch()
  const navigate = routeApi.useNavigate()

  const onClose = () =>
    navigate({
      to: routes.bank.relationships.details,
      params: { id: id.toString() },
      hash: 'contacts',
      replace: true,
      resetScroll: false,
      hashScrollIntoView: false,
      startTransition: false
    })

  return (
    <ContactMetadataManage
      companyId={Number(id)}
      contactId={Number(contactId)}
      contactName={contactName}
      onClose={onClose}
      onSuccess={() => onClose()}
      isContactCreateFromRelationships={true}
    />
  )
}
